
import React, { useState, useContext, useEffect } from "react";
import { Card, CardBody, CardTitle, Col, Row, Container, Button } from "reactstrap";

import { isValidEmail } from "../lib/formatData";
import UseMoondanceApi from "../lib/api";
import MoondanceLayout from "../lib/layout.js";

import { Link, useNavigate } from "react-router-dom";
import { MoondanceContext } from '../../App';
import Select from "react-select";

import MoondanceTable from "../lib/components/MoondanceTable.js";
//MoondanceApi.exportAccount,createAccount, inviteUser, listAccountUsers, updateUserAccess,  fetchOwners,   updateAccountName } 


const formatOptions = ({ data, innerProps, isFocused }) => {
    const { label, description, value } = data;
    return (
        <div {...innerProps} value={value} style={{ padding: '0.4em', backgroundColor: isFocused ? '#deebff' : 'white' }}>
            <div>{label}</div>
            {(description ? <div style={{ fontSize: '90%', }}>{description}</div> : '')}
        </div>
    );
};
const countAdmins = (array) => {
    return array.filter(item => item && item.access_type === "admin").length;
}


const Export = () => {

    const [user_data, setUserData] = useState([]);
    const moondanceApi = UseMoondanceApi();
    //const [id, setId] = useState("");
    const [accounts, setAccounts] = useState([]);
    const [initialValue] = useState({});
    const [submitResult, setSubmitResult] = useState(false);
    const [showEditAccountName, setShowEditAccountName] = useState(0);
    const [showAddAccountName, setShowAddAccountName] = useState(0);
    const [accessRightTypes] = useState([{ label: 'Admin', id: 'admin' }, { label: 'User', id: 'user' }, { label: 'Read Only', id: 'read' }, { label: 'No Access', id: 'NO' }]);
    const [newAccessRights, setNewAccessRights] = useState({});
    const [showAddUser, setShowAddUser] = useState(0);
    const [addNewUser, setAddNewUser] = useState({ name: '', email: '', access: 'user', account_id: '' });
    const [addUserError, setAddUserError] = useState(false);
    const [activeAccountForm, setActiveAccountForm] = useState(0);
    const [newAccountName, setNewAccountName] = useState('Your Account');

    const { lastUpdate } = useContext(MoondanceContext);
    const [accountAccessRights, setAccountAccessRights] = useState({
        "1": [
            {
                // data for account 1
            }
        ],
        "2": [
            {
                // data for account 2
            }
        ],
    });
    // const [errors, setErrors] = useState({});

    function fetchUserProfile() {
        moondanceApi.getLoggedinUser().then(profile => {

            if (profile) {
                var initValue = initialValue;
                setUserData(profile.data);


            }


        }).catch(errors => {
            console.log(errors)
        });
    }
    function fetchAccounts() {


        moondanceApi.fetchAccounts(Date.now()).then(response => {

            if (response.data.length > 0) {
                console.log(response.data);
                setAccounts(response.data);
                const tmpAccessRights = {}; // Initialize a temporary object
                const adminPromises = [];
                const newAccountAccessRights = [];

                Promise.all(adminPromises).then(() => {
                    setAccountAccessRights(tmpAccessRights); // Update state after all promises are resolved
                    setNewAccessRights(newAccountAccessRights);
                    console.log(tmpAccessRights); // Now this should reflect the updated state
                });
            } else {
                console.log('No account found');
            }
        }).catch(error => {
            console.log(error);
        });
    }

    useEffect(() => {
        fetchUserProfile();
        fetchAccounts();
    }, [submitResult, lastUpdate]);






    function setAccountName(id, value) {
        //  console.log(id)
        // console.log(value)
        //console.log(accounts)
        var tmp = accounts
        tmp.map((account, index) => (
            account.id === id ? account.n = value : ''
        ))
        setAccounts(tmp)
        //console.log(tmp)
    }

    function saveAccountName(id) {
        var requestData = {
            id: id,
            name: accounts.find(item => item.id === id).n
        }


        moondanceApi.updateAccountName(requestData).then(response => {
            //console.log(response)
            setShowEditAccountName(0)

        }).catch(error => {
            setSubmitResult(error)
            console.log(submitResult)
            return false
        });

    }
    function setAccessType(account_id, user_id, value) {
        setNewAccessRights(prevRights => {
            const updatedRights = { ...prevRights };
            if (!updatedRights[account_id]) {
                updatedRights[account_id] = {};
            }
            updatedRights[account_id][user_id] = value;
            return updatedRights;
        });



    }

    function addNewUserData(id, value) {
        var tmpNewUser = addNewUser;
        tmpNewUser[id] = value;
        setAddNewUser(tmpNewUser);

    }

    function createNewAccount() {
        console.log(newAccountName)
        var requestData = {
            name: newAccountName
        }

        console.log(requestData)

        moondanceApi.createAccount(requestData).then(response => {
            //console.log(response)
            setShowEditAccountName(0)
            showAddAccountName(0)
            fetchAccounts();

        }).catch(error => {
            setSubmitResult(error)
            console.log(submitResult)
            return false
        });
    }

    function addNewuser(account_id) {
        var tmpNewUser = addNewUser;
        tmpNewUser['account_id'] = account_id;
        setAddNewUser(tmpNewUser);
        setActiveAccountForm(account_id)

        if (!isValidEmail(tmpNewUser['email'])) {
            setAddUserError('Please enter a valid email address !')
        } else {
            setAddUserError(false)

            var requestData = {
                account_id: account_id,
                user_name: (tmpNewUser['name'] !== '' ? tmpNewUser['name'] : tmpNewUser['email']),
                user_email: tmpNewUser['email'],
                user_access: tmpNewUser['access'],

            }


            moondanceApi.inviteUser(requestData).then(response => {

                response.accountId = account_id
                setSubmitResult(response)
                console.log(response)

                setShowAddUser(0)

            }).catch(error => {
                setSubmitResult(error)
                console.log(submitResult)
                return false
            });


        }
        console.log(tmpNewUser)

    }
    function confirmSetAccessType(account_id, user_id, value) {

        var requestData = {
            id: account_id,
            user_id: user_id,
            access_type: value

        }
        moondanceApi.updateUserAccess(requestData).then(response => {
            setSubmitResult(response)
            console.log(response)
            setNewAccessRights(prevRights => {
                const updatedRights = { ...prevRights };
                if (!updatedRights[account_id]) {
                    updatedRights[account_id] = {};
                }
                updatedRights[account_id][user_id] = 'confirmed';
                return updatedRights;
            });

        }).catch(error => {
            setSubmitResult(error)
            console.log(submitResult)
            return false
        });
    }

    function exportToExcel(id) {
        var requestData = {
            accountId: id
        }
        moondanceApi.exportAccount(requestData).then(response => {
            console.log(response)

        }).catch(error => {
            setSubmitResult(error)
            console.log(submitResult)
            return false
        });


    }


    return (

        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Row>

                        <form className="user">
                            <h1><i className="mdi mdi-microsoft-excel"></i>Export your data</h1> <hr />
                            <table className="MoondanceTable table-centered">
                            <thead>
                                            <th>Account Id</th>
                                            <th>Name</th>
                                            <th>Export</th>
</thead>
                            {accounts.length > 0 ?

                                accounts.map((account, index) => (
                                        <tr>
                                            <td>{account.id}</td>
                                            <td>{account.n}</td>
                                        

                                        {(account.access === 'admin' ?
                                          
                                                <td>
                                                    <Button className="btn btn-outline-primary" onClick={() => { exportToExcel(account.id) }}><i className="mdi mdi-microsoft-excel"></i>{" "}Export data (Excel)</Button>
                                                </td>

                                            : 
                                                  <td> Need Admin Access </td>

                                        )}

                                    </tr>
                                  
                                )) : (<p> You currently don't have access to any accounts. You can request an invitation from someone with admin rights, or you can create a new account.</p>)}

</table>
                           


                        </form>

                    </Row>
                </Container>
            </div >
        </React.Fragment >




    )

}

/*<input type="text" className="form-control "
                    defaultValue={account.n}
                    onChange={e => setAccountName(account.id, e.target.value)}
                />*/

/*
 <Row className="mb-3">
                    <label for="email">Email</label>
                    <input type="email" className="form-control "
                        id="signup_form_email" required />
 
                    <p id="signup_form_email-error" className="error mt-2 text-danger"></p>
                </Row>
                <Row className="mb-3">
 
                    <label for="email">Choose a password</label>
                    <input type="password" className="form-control "
                        id="signup_form_password" placeholder="Password" />
 
                    <p id="signup_form_password-error" className="error mt-2 text-danger"></p>
                </Row>
                <Row className="mb-3">
 
                    <label for="email">Repeat password</label>
                    <input type="password" className="form-control "
                        id="signup_form_confirm_password" placeholder="Password" />
 
                    <p id="signup_form_confirm_password-error" className="error mt-2 text-danger"></p>
                </Row>
                <Row className="mb-3">
 
                    <label for="email">Multiple factor authentication</label>
                    <select className="form-control" id="signup_form_MFA">
                        <option value="null">No Double factor authentication (NOT Recommended)</option>
                        <option value="sms">Send a confirmation code by SMS each time I try to login from an unknown device</option>
                        <option value="email">Send a confirmation code by EMAIL each time I try to login from an unknown device</option>
                    </select>
                </Row>
                */

export default Export;